import { onMounted, onUnmounted, onUpdated, ref } from 'vue';

export function useStickyOffset(ids: string[]) {
  const offset = ref(0);

  const calculate = () => {
    offset.value = ids.reduce((acc, id) => {
      const el = document.getElementById(id);

      return el ? acc + el.offsetHeight : acc;
    }, 0);
  };

  onMounted(() => {
    window.addEventListener('resize', calculate);
    calculate();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', calculate);
  });

  onUpdated(calculate);

  return offset;
}
